

/**
 * Yup. Json. Reliability & simplicity before performance
 */
export const deepClone = (input) => JSON.parse(JSON.stringify(input))
